/*
 * See the file LICENSE for the full license governing this code.
 */

import './App.css';
import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './routes/Home';
import SignIn from './routes/SignIn';
import SignUp from './routes/SignUp';
import VerifyEmail from './routes/VerifyEmail';
import UserManagement from './routes/UserManagement';
import ResetPassword from './routes/ResetPassword';
import ConfirmResetPassword from './routes/ConfirmResetPassword';
import TermsOfService from './routes/TermsOfService';
import UpgradeUser from './routes/UpgradeUser';
import SuccessfulUpgrade from './routes/SuccessfulUpgrade';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, RequireAuth } from './components/authentication';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './api';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Instances from './components/Instances';
import UnexpectedError from './components/ErrorHandling/UnexpectedError';
import { BETA_TESTING } from './constants';

const mdTheme = createTheme({
  palette: {
    primary: {
      main: '#e6b325',
    },
    secondary: {
      main: '#2558e6',
    },
    webviewPrimary: {
      light: '#9be7ff',
      main: '#64b5f6',
      dark: '#2286c3',
    },
  },
});

function RoutesApp() {
  const ProtectedHome = (
    <RequireAuth>
      <Home />
    </RequireAuth>
  );
  const protectedHomeChildren = (
    <>
      <Route index element={<Instances />} />
      <Route path="user" element={<UserManagement />} />
      <Route path="upgrade-user" element={<UpgradeUser />} />
      <Route path="checkout/return" element={<SuccessfulUpgrade />} />
    </>
  );
  return (
    <Routes>
      <Route path="/index.html" element={ProtectedHome}>
        {protectedHomeChildren}
      </Route>
      <Route path="/" element={ProtectedHome}>
        {protectedHomeChildren}
      </Route>
      <Route path="/signin" element={<SignIn />} />
      {BETA_TESTING ? null : <Route path="/signup" element={<SignUp />} />}
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/reset-password/verify-email"
        element={<VerifyEmail navigateTo="/confirm-password-reset" />}
      />
      <Route
        path="/confirm-password-reset"
        element={<ConfirmResetPassword />}
      />
      <Route
        path="*"
        element={
          <main style={{ padding: '1rem' }}>
            <p>There's nothing here!</p>
          </main>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider theme={mdTheme}>
      <QueryClientProvider client={queryClient}>
        <UnexpectedError>
          <div className="App" style={{ height: '100vh' }}>
            <CssBaseline />
            <AuthProvider>
              <RoutesApp />
            </AuthProvider>
          </div>
        </UnexpectedError>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
